export default "__VITE_ASSET__TgJC4wLC__"